import { Field } from "../types/stylepacks";

const genericMainText: Field = {
	name: 'Main Text',
	type: 'string',
	default: 'Your copy here',
	options: [],
	variables: [],
	required: true,
	userData: 'default1',
	validation: null,
};
const genericSubtext: Field = {
	name: 'Subtext',
	type: 'string',
	default: 'Your copy here',
	options: [],
	variables: [],
	required: true,
	userData: 'default2',
	validation: null,
};
const genericColor1: Field = {
	name: 'Color 1',
	type: 'color',
	default: '#FEF75D',
	options: [],
	variables: [],
	required: false,
	userData: 'color4',
	validation: null,
};
const genericColor2: Field = {
	name: 'Color 2',
	type: 'color',
	default: '#53DFFD',
	options: [],
	variables: [],
	required: false,
	userData: 'color5',
	validation: null,
};
const genericColor3: Field = {
	name: 'Color 3',
	type: 'color',
	default: '#9DFE74',
	options: [],
	variables: [],
	required: false,
	userData: 'color2',
	validation: null,
};
const genericColor4: Field = {
	name: 'Color 4',
	type: 'color',
	default: '#FE62E0',
	options: [],
	variables: [],
	required: false,
	userData: 'color1',
	validation: null,
};

export const lockedAssetFieldsOverlay: Field[] = [
	genericMainText,
	genericSubtext,
	genericColor1,
	genericColor2,
	genericColor3,
	genericColor4,
];

export const lockedAssetFieldsMedia: Field[] = [
	genericMainText,
	genericSubtext,
	genericColor1,
	genericColor2,
	genericColor3,
	genericColor4,
];
